<script>
  import ProductsCardsSlider from 'components/ProductsCardsSlider/ProductsCardsSlider.vue';
  import options from './ProductAddedOverlay.options'
  export default options
</script>

<template>
  <article class="kb-product-added-overlay">

    <div class="kb-product-added-overlay-body">
        <div class="kb-product-added-overlay-body__title">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="96" height="96" aria-hidden="true">
                <circle cx="16" cy="16" r="14" fill="#16a34a"/>
                <path d="M9 17 14 22 22 10" stroke="#ffffff" stroke-width="1.5" stroke-linejoin="round" fill="none"/>
            </svg>
            <h1>{{ getLabel('title') }}</h1>
        </div>

        <template v-if="recommendations?.length > 0">
            <ProductsCardsSlider
                sliderId="recommended-products-slider"
                glideBehaviour="slider"
                :type="sliderDisplayType"
                :link='{}'
                :showAddCta="true"
                :sizingFunction="sliderSizingFunction"
                :results="recommendations"
            />
        </template>

    </div>

    <div class="kb-product-added-overlay-footer" :class="{ 'kb-product-added-overlay-footer--has-recommendations': recommendations?.length > 0 }">
        <button class="kb-button" @click="closeOverlay">
            {{ getLabel('footerLeftCtaLabel') }}
        </button>
        <a :href="footerRightCtaUrl" class="kb-button kb-button--full-color-spot">
            {{ getLabel('footerRightCtaLabel') }}
        </a>
    </div>

  </article>
</template>
